import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useQuery } from '../../routes';
import { fromSubscription } from '../../store';
import { SubscriptionV2 } from './SubscriptionV2';
import {
  isBaselineFeature,
  SubscriptionSource,
} from '../../models';
import { isTrialSubscription } from './subscriptionTrial';

export const Subscription = () => {
  const { get } = useQuery();
  const accountId = Number(get('accountId'));
  const selectAccountSubscriptions = useMemo(
    () => fromSubscription.selectByAccountId(accountId),
    [accountId],
  );
  const accountSubscriptions = useSelector(selectAccountSubscriptions);
  const subscriptions = useMemo(
    () => accountSubscriptions.filter(
      sub => !isBaselineFeature(sub.feature)
        && (
          sub.source === SubscriptionSource.RECURLY
          || isTrialSubscription(sub)
        ),
    ),
    [accountSubscriptions],
  );

  return <SubscriptionV2 subscriptions={subscriptions} accountId={accountId} />;
};
